export enum SkeletonShape {
  CIRCLE = "circle",
  LINES = "lines",
}

export interface SkeletonProps {
  shape: SkeletonShape;
  lineHeight?: number;
  lineCount?: number;
  className?: string;
  width?: string | number;
  height?: string | number;
}

export default function Skeleton({
  shape,
  lineHeight = 16,
  lineCount = 1,
  className = "",
  width,
  height,
}: SkeletonProps) {
  const baseClasses = "animate-pulse bg-gray-200";

  if (shape === SkeletonShape.CIRCLE) {
    const size = height || width || 40;
    return (
      <div
        className={`${baseClasses} ${className}`}
        style={{
          width: typeof size === "number" ? `${size}px` : size,
          height: typeof size === "number" ? `${size}px` : size,
          borderRadius: "50%",
        }}
      />
    );
  }

  if (shape === SkeletonShape.LINES) {
    return (
      <div className={`space-y-2 ${className}`}>
        {Array.from({ length: lineCount }, (_, index) => (
          <div
            key={index}
            className={baseClasses}
            style={{
              height: `${lineHeight}px`,
              width: index === lineCount - 1 ? "75%" : "100%",
              borderRadius: "20px",
            }}
          />
        ))}
      </div>
    );
  }

  return null;
}
